<template>
  <div class="app-promotion">
    <div class="section section--header-and-image">
      <div>
        <fn-headline
          type="h2"
          size="h3"
        >
          {{ headline }}
        </fn-headline>
      </div>

      <div v-if="imageData?.url">
        <fn-picture
          :src="imageData.url"
          :alt="imageData.alt"
          :title="imageData.title"
          :width="imageData.width"
          :height="imageData.height"
          :lazy="false"
        />
      </div>
    </div>

    <div class="section section--list-and-cta">
      <div v-if="isPropDataValid(listData)">
        <fn-icon-text-list :items="listData.items" />
      </div>

      <div
        v-if="isPropDataValid(ctaData)"
        class="app-promotion--cta"
      >
        <fn-link
          v-for="(cta, index) in ctaItems"
          :key="`${cta.link.url}-${index}`"
          :href="cta.link.url"
          no-arrow
        >
          <fn-picture
            :src="cta.image.url"
            :alt="cta.image.alt"
            :title="cta.image.title"
            :width="148"
            :height="44"
          />
        </fn-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headline: {
      type: String,
      default: '',
    },
    imageData: {
      type: Object,
      default: () => ({}),
    },
    listData: {
      type: Object,
      default: () => ({}),
    },
    ctaData: {
      type: [Object, Array],
      default: () => [],
    },
  },
  computed: {
    ctaItems() {
      if (Array.isArray(this.ctaData)) {
        return this.ctaData;
      }

      return Object.keys(this.ctaData)
        .map((key) => (key > 0 ? this.ctaData[key].components[0] : null))
        .filter((item) => !!item);
    },
    isPropDataValid: () => (propData) => {
      if (Array.isArray(propData)) {
        return propData.length;
      }

      return Object.keys(propData || {}).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-promotion {
  $gap: 1.5 * $pad;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: $content-max-width;
  gap: $gap;
  margin: $ui-height 0;

  @include bp(m, max) {
    flex-direction: column;
    padding: 0 $pad;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: $gap;
    align-self: flex-end;

    &--header-and-image {
      @include bp(m, max) {
        align-self: center;
      }
    }
  }

  &--cta {
    display: flex;
    flex-direction: row;
    gap: $pad;
  }
}
</style>
